import React, { Component } from 'react'
import { LayoutColumn } from 'client/shared/blocks/layout-column'
import { Heading } from 'client/shared/blocks/heading'
import Spacer from 'client/shared/blocks/spacer'
import Footer from 'client/shared/blocks/footer'
import './jobs-layout.styl'

import jobs from './jobs.json'
import Linka from 'client/shared/blocks/linka/linka'
type Job = { jobId: string; job: string }

export default class JobsLayout extends Component {
  render(): JSX.Element {
    return (
      <LayoutColumn>
        <Spacer size="top-page" />
        <Heading kind="kazimir">
          You, Bookmate and some{' '}
          <span className="underlined-decor">books to be read</span> jobs to be
          done
        </Heading>
        <Spacer size={32} />
        <p>
          Here, we build applications that make reading or listening to books
          even better. Over the years, we’ve also built a company that we love.
          Come say hi (and maybe stay for a while?)
        </p>
        <article>
          <Heading kind="kazimir" rank={2}>
            The Product
          </Heading>
          <p>
            Bookmate is a subscription based e-book service that makes reading
            accessible to anyone in the world with a mobile phone. We inspire
            millions of people around the globe to read more, discover new books
            and find new friends with common interests.
          </p>
          <p>
            Bookmate brings readers, authors, publishers, brands and
            distribution partners together through a strong business model.
            Bookmate is actively growing in Europe (including Scandinavia and
            the Balkans), Latin America, South East Asia and Africa.
          </p>
          <p>
            Numbers? Easy: 13M users, around 2M books, audiobooks and comic
            books in our catalog, 16 languages and 20K publishers.
          </p>
        </article>
        <article>
          <Heading kind="kazimir" rank={2}>
            The Team
          </Heading>
          <p>
            We are an international and distributed team of enthusiasts who love
            books, reading and being a part of something bigger than ourselves.
            We’re thinking about creating a dreamy bookish lifestyle.{' '}
          </p>
          <p>
            Meaning that yeah, our business is partly built on content
            distribution, but we really would like to build a whole experience
            of reading, listening, learning and being together for our customers
            and ourselves - and make our app an inseparable part of it.
          </p>
          <p>
            We like to think of ourselves as a fantastic crew, and we’re always
            ready to welcome someone on board.
          </p>
        </article>
        <article>
          <Heading kind="kazimir" rank={2}>
            The Tech
          </Heading>
          <p>
            We’re building our dream around 3 customer-faced products (website,
            iOS app and Android app). Our reader is considered best-in-class in
            the whole industry of reading apps.
          </p>
          <p>
            Not in the mood for something facing the customer? Not a problem, we
            also constantly develop a plethora of services that make
            communication with external partners possible (including the
            partners who publish the books, the partners who provide Bookmate to
            their customers as a form of bundle service, etc..). Naturally, we
            also have internal systems that keep all this up and running. You
            can find practically any type of interesting project in our
            ecosystem.
          </p>
          <p>
            Our code base is 10+ years old and incorporates over 50k commits,
            but we’re always open to any innovations in terms of code or
            technologies applied to achieve business results.{' '}
          </p>
        </article>
        <article>
          <Heading kind="kazimir" rank={3}>
            Come work with us
          </Heading>
          <ul className="jobs-layout__list">
            {jobs.map((job: Job, i: number) => (
              <li key={i} className="jobs-layout__item">
                <Linka path={`/about/jobs/${job.jobId}`}>{job.job}</Linka>
              </li>
            ))}
          </ul>
          {/* <Trans
            id="footer.jobs_none_desc"
            components={[<a href="mailto:work@bookmate.com"></a>]}
          /> */}
        </article>
        <Spacer size={56} />
        <Footer aboutMenu />
      </LayoutColumn>
    )
  }
}
